<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<h2 class="h2"><a id="page_vi"></a><a id="contents"></a><span class="smallcaps">CONTENTS</span><br/>.  .  .</h2>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02">Introduction: The American Mafia</a></p>
<p class="toc-entry"> <a href="#/xhtml/chapter01">1. <strong>The Road to Apalachin:</strong> War Is Declared on the American Mafia</a></p>
<p class="toc-entry"> <a href="#/xhtml/chapter02">2. <strong>Top Hoodlums:</strong> The FBI Plays Catch-up</a></p>
<p class="toc-entry"> <span href="#/xhtml/chapter03" title="Link target outside of Sample">3. <strong>Wheeling and Dealing with Mobsters:</strong> The Friends of Jimmy Hoffa</span></p>
<p class="toc-entry"> <span href="#/xhtml/chapter04" title="Link target outside of Sample">4. <strong>“Do Something About It”:</strong> Bobby Kennedy’s Attack on the Mobs</span></p>
<p class="toc-entry"> <span href="#/xhtml/chapter05" title="Link target outside of Sample">5. <strong>Hail Colombo:</strong> The Mafia Makes a Comeback</span></p>
<p class="toc-entry"> <span href="#/xhtml/chapter06" title="Link target outside of Sample">6. <strong>From Havana to Dallas:</strong> The Sunbelt Mafia and the Killing of JFK</span></p>
<p class="toc-entry"> <span href="#/xhtml/chapter07" title="Link target outside of Sample">7. <strong>Actors on the Same Stage:</strong> Organized Crime and Corrupt Politicians</span></p>
<p class="toc-entry"> <span href="#/xhtml/chapter08" title="Link target outside of Sample">8. <strong>Strawmen:</strong> Skimming Vegas</span></p>
<p class="toc-entry"> <span href="#/xhtml/chapter09" title="Link target outside of Sample">9. <strong>The Mob and the Teamsters:</strong> Jimmy’s Fate, Jackie’s Dilemma</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10. <strong>From the French Connection to the Pizza Connection:</strong> Drugs, the Mafia, and Its Would-be Successors</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter11" title="Link target outside of Sample">11. <strong>RICO:</strong> Decommissioning the Commission</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter12" title="Link target outside of Sample">12. <strong>The Defector and the Don:</strong> Taking Down John Gotti</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter13" title="Link target outside of Sample">13. <strong>Dealing with the Devil:</strong> The Hunt for “Whitey”</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter14" title="Link target outside of Sample">14. <strong>Stinging the Mobs:</strong> Digging Out the Mafia Root and Branch</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter15" title="Link target outside of Sample">15. <strong>The Future of the Old Mafia:</strong> The Emergence of the New</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">Notes</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter03" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter04" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?064fd1fd